import { defineStore } from 'pinia'
import { ref } from 'vue'

export type NavigationGuard = () => boolean | Promise<boolean>

export const useNavigationGuardStore = defineStore('navigationGuard', () => {
  const guards = ref<NavigationGuard[]>([])

  const addGuard = (guard: NavigationGuard) => {
    guards.value.push(guard)
  }

  const removeGuard = (guard: NavigationGuard) => {
    guards.value = guards.value.filter(g => g !== guard)
  }

  const checkGuards = async () => {
    for (const guard of guards.value) {
      const result = await guard()
      if (!result) return false
    }
    return true
  }

  return {
    guards,
    addGuard,
    removeGuard,
    checkGuards
  }
})
